import React, { Component } from 'react';
import { withStyles } from "@material-ui/core/styles";
import * as aserver from '../../APIClient';
import PolicyList from "../comps/policyList";
import CoachQuestions from "../comps/coachQuestions";
import Button from '@material-ui/core/Button';
import * as utils from "../../Utilities";
import { withRouter } from 'react-router-dom';
import PropTypes from "prop-types";
import AlertModal from "../comps/alertModal";
import Modal from "../comps/modal";
import LoadingBackdrop from '../comps/loadingBackdrop';
import Toast from "../comps/alertMessage";
import DonutGraph from "../comps/donutGraph";
import DoneIcon from '@material-ui/icons/Done';
import { announceCoach } from '../../tabLock';
import'./main.css';

const drawerWidth = 240;

const styles = theme =>  ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100%',
    overflow: 'hidden',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: '90vh',
  },
});

// eslint-disable-next-line 
class Home extends Component {  constructor(props) {
    super(props);
    this.state = {
        coachName: "",
        coachSurname: "",
        coachId: localStorage.getItem("Id"),
        name: "",
        surname: "",
        email: "",
        selectValue: "",
        tokenType: "paid",
        company: "",
        disabled: "",
        disableTypeOfTest:false,
        showToast: false,
        level:"",
        message:"",
        modalIsOpen: false,
        modalIsOpenTeam:false,
        clientModalTitle: 'x',
        clientModalSubmitFunction: this.addClient,
        clientModalSubmitCaption: 'x',
        allRecords:[],
        openAlertModal: false,
        openPolicyAlertModal: false,
        openCoachQuestionsModal: false,
        coachQuestionnaireAlert: false,
        coachQuestionsAfterPolicies: false,
        messageBody:[],
        openBackdrop: false,
        loading: true,
        isAssistant: localStorage.getItem("isBeingAssisted")==="true"?true:false,
        assistantName:localStorage.getItem("assistantName")
        };
  }

  openAlertModal = (title, message) => {
    this.setState({
      alertModalTitle: title,
      alertMessage: message,
      openAlertModal: true,
    })
  }

  fetchDashboardInfo = async()=>{
    let coachId = localStorage.getItem("Id")
    let response = await aserver.get(`api/v2/coaches/${coachId}/dashboardInfo`);
    this.setState({
      coachName: response.data.coachName,
      coachSurname:response.data.coachSurname,
    });
    localStorage.setItem("coachEmailAddress", response.data.coachEmail)

    let coachQuestionnaireAlert = this.state.isAssistant ? false : response.data.coachQuestionnaireAlert;
    this.setState({ coachQuestionnaireAlert: coachQuestionnaireAlert });

    if (response.data.policyAlert) {
      this.setState({
        openPolicyAlertModal: true,
        openBackdrop:true
      })
    } else if (coachQuestionnaireAlert) {
      this.setState({
        openCoachQuestionsModal: true,
        openBackdrop:true
      })
    }

    if (response.data.messagesToAck.length>0) {
      this.setState({
        messageBody: response.data.messagesToAck
      })
      this.openAlertModal();
      if (localStorage.getItem("impersonator")!=='true')
        aserver.get(`api/v3/coaches/${this.state.coachId}/ackedLatestMessages`);
    }

    let allRecords = response.data.tokens;
    
    for(let record of allRecords) {

      if(record.assessmentType === "ennea"){
        record.assessmentType = "Enneagram"
      }

      if(record.assessmentType === "EIT"){
        record.assessmentType = "IMf"
      }

      if(record.assessmentType === "full"){
        record.assessmentType = "Full"
      }
    }
    this.setState({ allRecords: allRecords, loading: false });
  }

  openAddClientModal = ()  => {
    aserver.goto('/coachportal/assessments');
    localStorage.setItem("ReRoute", true)
  }

  openAddTeamModal = ()  => {
    aserver.goto('/coachportal/teams');
    localStorage.setItem("ReRoute", true)
  }

  jumpToAssessmentsPage = () =>{
    aserver.goto('/coachportal/assessments');
  }

  jumpToClientssPage = () =>{
    aserver.goto('/coachportal/clients');
  }

  jumpToAssessmentsPageWithAppliedFilter=(fb)=>{
    aserver.goto('/coachportal/assessments');
    localStorage.setItem("functionFilterId", fb.id)
  }

  downloadSpreadsheet = async()=>{
    this.setState({openBackdrop:true});
    this.toastMessage("Downloading...", "success")
    let downloadResponse = await aserver.download(`api/v2/coaches/${this.state.coachId}/downloadActivitySummary`);
    if(downloadResponse.status !== 200){
      this.openAlertModal("Failed", downloadResponse.data.error.info)

    }
    this.setState({openBackdrop:false});
  }

  toastMessage = (text, level) =>{
    this.setState({
      message:text,
      level: level
    })
    this.showToast()
  }

  showToast = () => {
    this.setState(
      {
        showToast: true
      },
      () => {
        setTimeout(() => this.setState({ showToast: false }), 2500);
      }
    );
  }

  escFunction =(event)=>{
    if(event.keyCode === 27) {
      this.setState({
        modalIsOpen: false,
        disabled: false,
        disableTypeOfTest:false,
      });   
    }
  }

  closeModal = () => {
    this.setState({
      openAlertModal: false,
    });
  }

  closeCoachQuestionsModal = () => {
    this.setState({
      openCoachQuestionsModal: false,
      openBackdrop: false,
    });
  }
  componentWillUnmount(){
    document.removeEventListener("keydown", this.escFunction, false);
  }
  
  componentDidMount=()=>{
      this.fetchDashboardInfo()
      document.addEventListener("keydown", this.escFunction, false);
      announceCoach(this.state.coachId);
  }


  render() {
    const classes = this.props.classes;
    const {coachName, coachSurname, allRecords, messageBody, isAssistant, assistantName} = this.state
    const colors = ['#98CA3F','#f7993b']

  
    let headingMessage = <></>
    headingMessage = <>
                    <h1 className='dashboardHeading'>Hello <span style={{display:isAssistant?"inline-block":"none"}}>{assistantName} assisting</span> {coachName} {coachSurname},</h1> 
                    <h2 className='desktopGreeting'>Welcome to the Aephoria Coach Portal.</h2> 
                    <h3 className='mobileGreeting'>Welcome to the Aephoria Coach Portal's mobile view, which offers some features you might need when you're on the go. For complete functionality, including better overviews of clients and assessment progress, and management of teams, please access this site on your desktop.</h3> 
                  </>
    let newMessages =<></>
    newMessages = messageBody.map(i =>  {return <><h2>{i.subject}</h2><p dangerouslySetInnerHTML={{__html: i.body}}></p></>})
    
    // eslint-disable-next-line
    return (
        <main className="dashboard">
                  {this.state.loading ? <h2>Please wait, loading...</h2> : <>
                  {headingMessage}

                  {this.props.onlyMiniAssessment?<h3>Your access is limited to Aephoria's Mini-Assessment offering.</h3>:<>
                  <div style={{display:this.state.isAssistant?"block":"none"}}>
                    <h3>Please note that your actions on this portal (creating assessments, team reports, ordering bulk credits) have financial implications for your coach. Also, the data in the Coach Portal includes sensitive and protected personal information. Your coach is liable for how this information is used and shared, so please handle with care and discuss further with your coach.
                    </h3>
                    <h3>You can request a free demo of the system by sending an email to accreditations@aephoriagroup.com . We also suggest that you watch the videos in this <a href='https://www.youtube.com/playlist?list=PLWA47UiOOB-c' target="_blank" rel="noopener noreferrer"><u>playlist</u></a> for an overview of how the system works.</h3>
                    <h3> If you're interested in becoming a certified Enneagram coach, please visit our website at <a href='https://aephoriagroup.com/aim-assessments-2/' target="_blank" rel="noopener noreferrer"><u>aephoriagroup.com</u></a> for more information.</h3>
                  </div>
                  <div className='dashboardButtonDiv'>
                    <Button className='dashboardButtons ' variant="contained" color="primary" onClick={this.jumpToAssessmentsPage}>View Assessments</Button>
                    <Button className='dashboardButtons desktopGreeting' variant="contained" color="primary" onClick={this.openAddClientModal}>Add New Client</Button>
                    <Button className='dashboardButtons desktopGreeting' variant="contained" color="primary" onClick={this.openAddTeamModal}>Add New Team</Button>        
                    <Button className='dashboardButtons desktopGreeting' variant="contained" color="primary" onClick={this.downloadSpreadsheet}>Download Summary Spreadsheet</Button>
                  </div>
                  <div className='dashboardDiv'>
                    {utils.filterButtons.map(fb => {
                        if (fb.id === 'filterSCO') {
                          return null;
                        }
                        const x = allRecords.filter(fb.filterFunction).length;
                        const caption = (fb.caption === 'Show all') ? 'Total' : fb.caption;
                        const completedCount = allRecords.filter(record => record.guestCompletedAt && record.userReport === 'sent').length;
                        const incompleteCount = allRecords.length - completedCount;

                        return (
                          <div className="dashboardActionTile" key={fb.id}>
                            {caption === 'Total' ? (
                            <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                              <DonutGraph data={[completedCount, incompleteCount]} colors={colors} width={150} height={150} total={x} textColor="#00447D" />
                              <div style={{ position: 'absolute', top: 0, left: -55, display: 'flex', flexDirection: "row-reverse" ,alignItems: 'center' }}>
                                <div style={{ width: '10px', height: '10px', backgroundColor: colors[1], marginLeft: '5px' }}></div>
                                <div>In progress</div>
                              </div>
                              <div style={{ position: 'absolute', top: 0, right: -55, display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '10px', height: '10px', backgroundColor: colors[0], marginRight: '5px' }}></div>
                                <div>Completed</div>
                              </div>
                            </div>
                            ) : (
                              <div className='dashboardCircles'>
                              {x === 0 ? (
                                <div className='dashboardCompleteIcon' onClick={() => {this.jumpToAssessmentsPageWithAppliedFilter(fb);}} style={{cursor: 'pointer' }} >
                                  <DoneIcon className='completedIcon'/>
                                </div>
                              ) : (
                                <div className='dashboardCircleNumber'  
                                onClick={() => {
                                  this.jumpToAssessmentsPageWithAppliedFilter(fb);
                                }}
                                style={{cursor: 'pointer' }}
                                >{`${x}`}</div>
                              )}
                            </div>
                            )}
                              <u
                                className='urlLink'
                                style={{cursor: 'pointer' }}
                                onClick={() => {
                                  this.jumpToAssessmentsPageWithAppliedFilter(fb);
                                }}
                              >
                                {caption}
                              </u>
                          </div>
                        );
                      })
                    }
                  </div></>}
                </>}

                <AlertModal
                  message={this.state.alertMessage}
                  modalTitle={this.state.alertModalTitle}
                  isOpen={this.state.openAlertModal}
                  showClose={() => this.closeModal()}
                >
                  {newMessages}
                </AlertModal>

                <AlertModal
                  message={this.state.alertMessage}
                  modalTitle='Policies to sign or accept'
                  isOpen={this.state.openPolicyAlertModal}
                  showClose={async () => {
                    let allowClose = true;
                    if (this.state.overdue) {
                      let response = await aserver.get(`api/v2/coaches/${this.state.coachId}/policyAlert`);
                      allowClose = !response.data.policyAlert;
                    }
                    if (allowClose) {
                      // dashboardInfo deliberately skipped this check while a policy alert was
                      // showing, so re-check it fresh now that policies are actually dealt with.
                      let coachQuestionnaireAlert = false;
                      if (!this.state.isAssistant) {
                        let cqResponse = await aserver.get(`api/v2/coaches/${this.state.coachId}/coachQuestionnaireAlert`);
                        coachQuestionnaireAlert = cqResponse.data.coachQuestionnaireAlert;
                      }
                      if (coachQuestionnaireAlert) {
                        // chain straight into the light-touch "one last thing" modal, keeping the backdrop up
                        this.setState({ openPolicyAlertModal: false, openCoachQuestionsModal: true, coachQuestionnaireAlert, coachQuestionsAfterPolicies: true });
                      } else {
                        this.setState({ openPolicyAlertModal: false, openBackdrop:false });
                      }
                    }
                  }}
                >
                  <PolicyList onlyActionable={true} coachUUID={this.state.coachId} onOverdue={()=>{this.setState({overdue: true})}}/>
                  <p>At any time you can refer to, and if necessary sign / accept, policies in your user profile (click at the top left on your name), in the "Policies" section.</p>
                  <p>If you would like to discuss the agreements before accepting and signing, please contact <a href="mailto:accreditations@aephoriagroup.com" target="_blank" rel="noreferrer">accreditations@aephoriagroup.com</a> with your questions.</p>
                </AlertModal>

                <Modal isOpen={this.state.openCoachQuestionsModal} onClose={this.closeCoachQuestionsModal}>
                  <h2 style={{margin:"0"}}>{this.state.coachQuestionsAfterPolicies ? 'One last thing to help us improve your experience' : 'Please help us improve your experience'}</h2>
                  <p>A few quick questions to help us understand you and your practice better. You can<br/>
                  skip this for now and answer it later from your User Profile page, under "Get to Know You".</p>
                  <CoachQuestions coachUUID={this.state.coachId} allowSkip={true} pingOnMount={true} onDone={this.closeCoachQuestionsModal} />
                </Modal>

                {/*================================= This is the toast modal ======================================*/}

                <Toast
                  level={this.state.level}
                  message={this.state.message}
                  visible={this.state.showToast}
                />
          <LoadingBackdrop open={this.state.openBackdrop} />
        </main>
    )
  }
}

Home.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(withRouter(Home));

 